module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 011.b37e78ee.jpg";